export default {
    '/*': {
        title: 'Search Results'
    }
};
